module.exports = __webpack_public_path__ + "img/united-church.0b7c58bb.png";